import React, { useState } from "react";
import Shelf from "./shelf";
import { Carrier as CarrierType } from "/app/src/models";
/**
 * Displays carrier information along with its associated shelf.
 *
 * @param {object} props - The properties object.
 * @param {CarrierType} props.carrier - The carrier data.
 * @returns {JSX.Element} A JSX element representing the carrier.
 */
export default function Carrier({ carrier }: { carrier: CarrierType }) {
  const [showShelf] = useState(true);

  return (
    <div className="carrier">
      <h3>{carrier.name}</h3>
      {showShelf && <Shelf carrier={carrier} />}
    </div>
  );
}
